import { UPDATE_LINE_ITEM_REQUEST, UPDATE_LINE_ITEM_SUCCESS, UPDATE_LINE_ITEM_ERROR, UPDATE_LINE_ITEM_IN_BASKET_ERROR } from '../constants/ActionTypes'
import type GenericAction from './types/genericAction.types'

export type IsUpdatingLineItemAction = GenericAction<
    typeof UPDATE_LINE_ITEM_REQUEST | typeof UPDATE_LINE_ITEM_SUCCESS | typeof UPDATE_LINE_ITEM_ERROR | typeof UPDATE_LINE_ITEM_IN_BASKET_ERROR,
    { partNumber: number }
>

type State = {
    [key: string]: boolean
}

const isUpdatingLineItem = (state: State = {}, action: IsUpdatingLineItemAction) => {
    switch (action.type) {
        case UPDATE_LINE_ITEM_REQUEST:
            return { ...state, [action.partNumber.toString()]: true }

        case UPDATE_LINE_ITEM_SUCCESS:
        case UPDATE_LINE_ITEM_ERROR:
        case UPDATE_LINE_ITEM_IN_BASKET_ERROR: {
            const { [action.partNumber.toString()]: ignore, ...nextState } = state
            return nextState
        }

        default:
            return state
    }
}

export default isUpdatingLineItem
